<template>
  <div class="router-view dashboard-page-wrapper flex-col" id="router-view">
    <keep-alive>
      <router-view v-bind="$attrs" >
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "VueDashboardPageRoot",
};
</script>

<style lang="scss" scoped>
</style>
